// src/screens/Merchant/SelectProductToSponsorScreen.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './SelectProductToSponsorScreen.css';

import backIcon from '../../assets/backarrow-icon.png';
import placeholderImg from '../../assets/placeholder-banner.png';

import PromoteProductDrawer from '../../components/popups/PromoteProductDrawer';

function SelectProductToSponsorScreen({ user }) {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

// screen-only toast (success | error)
const [toast, setToast] = useState({ visible: false, message: '', type: '' });
const showToast = (message, type = 'success') => {
  setToast({ visible: true, message, type });
  setTimeout(() => setToast({ visible: false, message: '', type: '' }), 2200);
};



  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get(`/products/by-username/${user.username}`);
        setProducts(res.data || []);
      } catch (err) {
        console.error('❌ Failed to load products:', err);
      } finally {
        setLoading(false);
      }
    };

    if (user?._id) fetchProducts();
  }, [user]);

  const handleOpenDrawer = () => {
    if (!selectedId) return;
    setDrawerVisible(true);
  };

const handleSubmitPromotion = async () => {
  try {
    await api.post('/sponsorships/submit', {
      productId: selectedId,
      username: user.username,
    });
    showToast(' Submitted for promotion review', 'success');
  } catch (err) {
    showToast(err.response?.data?.message || '❌ Failed to submit for promotion', 'error');
  } finally {
    setDrawerVisible(false);
    setAcceptTerms(false);
  }
};

  return (
    <div className="sponsor-screen-container">
      {/* 🔙 Topbar */}
      <div className="sponsor-screen-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="sponsor-screen-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2>Select Product to Sponsor</h2>
      </div>

      {/* 📦 Product List */}
      <div className="sponsor-products-list">
        {loading ? (
          <p>Loading products...</p>
        ) : products.length === 0 ? (
          <p>No products found. Add a product first.</p>
        ) : (
          products.map((product) => (
            <div
              key={product._id}
              className={`sponsor-product-card ${selectedId === product._id ? 'selected' : ''}`}
              onClick={() => setSelectedId(product._id)}
            >
              <img
                src={product.media?.[0] || placeholderImg}
                alt={product.name}
                className="sponsor-product-img"
              />
              <div className="sponsor-product-info">
                <strong>{product.name}</strong>
                <p>{product.price} Pi</p>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div className="sponsor-footer">
        <button
          className="sponsor-proceed-btn"
          disabled={!selectedId}
          onClick={handleOpenDrawer}
        >
          Proceed to Promote
        </button>
      </div>

      {/* Drawer */}
      <PromoteProductDrawer
        visible={drawerVisible}
        onClose={() => {
          setDrawerVisible(false);
          setAcceptTerms(false);
        }}
        onSubmit={handleSubmitPromotion}
        acceptTerms={acceptTerms}
        setAcceptTerms={setAcceptTerms}
      />
{toast.visible && (
  <div className={`sponsor-toast ${toast.type}`}>
    {toast.message}
  </div>
)}
  

  </div>
  );
}

export default SelectProductToSponsorScreen;
